import {
  Component, Input, Output, EventEmitter, ViewChild, DoCheck
} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';

import { ReceiversSearchComponent } from '../receivers-search/receivers-search.component';
import { PermissionsService } from 'shared/permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'receivers-header',
  templateUrl: 'receivers-header.component.html',
  styleUrls: ['receivers-header.component.scss'],
})
export class ReceiversHeaderComponent implements DoCheck {
  searchModelFiltersForAdvancedSearch: Array<ActiveFilterModel>;
  // hack of filters (objects array) ignore in ngOnChanges
  // https://github.com/angular/angular/issues/6458
  prevFilters: any[];

  @Input() headerColor: string;
  @Input() filters: Array<ActiveFilterModel>;
  @Input() searchValue: string;
  @Input() ghostValue: string;
  @Input() actions: any = [];
  @Input() pagesMenuData: any;
  @Input() currentPageData: any;
  @Input() statuses: any;
  @Input() statusModel: any;
  @Input() searchModel: any;
  @Input() searchService: any;
  @Input() searchResultsColumns: any;

  // pagination
  @Input() totalRecords: any;
  @Input() currentPage: any;
  @Input() itemsPerPage: any;

  // tabs
  @Input() isTabsClickableWhenActive: boolean = false;
  @Input() leftTabTitle: string;
  @Input() rightTabTitle: string;
  @Input() isLeftTabActive: boolean = false;
  @Input() isRightTabActive: boolean = false;

  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() searchValueChanged: EventEmitter<any> = new EventEmitter();
  @Output() filterRemove: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchCancel: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchClick: EventEmitter<any> = new EventEmitter();

  @Output() statusSelected: EventEmitter<any> = new EventEmitter();

  @Output() pageActionSelect: EventEmitter<any> = new EventEmitter();
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  @Output() itemsPerPageChange: EventEmitter<any> = new EventEmitter();
  @Output() leftTabClick: EventEmitter<any> = new EventEmitter();
  @Output() rightTabClick: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchRun: EventEmitter<any> = new EventEmitter();

  @ViewChild(ReceiversSearchComponent, {static: false})
  searchComponent: ReceiversSearchComponent | void;

  constructor(
    protected router: Router,
    protected permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get searchInputValue(): string {
    return this.searchComponent && this.searchComponent.searchInputValue;
  }

  get advancedSearchComponent(): any {
    return this.searchComponent && this.searchComponent.advancedSearch;
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngDoCheck() {
    if (!_.isEqual(this.filters, this.prevFilters)) {
      this.prevFilters = _.cloneDeep(this.filters);
    }
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public resetSearchValue(value: string) {
    if (this.searchComponent instanceof ReceiversSearchComponent) {
      this.searchComponent.resetSearchValue(value);
    }
  }

  public hasPermission(permissions: any) {
    return this.permissionsService.hasPermission(permissions);
  }

  /*******************************************
    * COMPONENT EVENT HANDLERS
   *******************************************/

   onFilterRemove(event: any) {
     // after filtering scorecard filter we get different filters array
     // thus after removing filter in this array we need to remove it from original array also
     _.remove(this.filters, event);
     this.filterRemove.emit(event);
   }

   onClearSearchClick() {
     this.clearSearchClick.emit();
   }

   onAdvancedSearchClick() {
     this.advancedSearchClick.emit();
   }

   onAdvancedSearchCancel() {
     this.advancedSearchCancel.emit();
   }

  onPageActionSelect(event: any) {
    this.pageActionSelect.emit(event);
  }

  onStatusSelected(event: any) {
    this.statusSelected.emit(event);
  }

  onLeftTabClick() {
    this.leftTabClick.emit();
  }

  onRightTabClick() {
    this.rightTabClick.emit();
  }

  onActionSelect(event: any) {
    this.pageActionSelect.emit(event);
  }

  onSearchValueChanged(event: any) {
    this.searchValueChanged.emit(event);
  }

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }

  onItemsPerPageChange(event: any) {
    this.itemsPerPageChange.emit(event);
  }

  onAdvancedSearchRun() {
    this.advancedSearchRun.emit();
  }
}
